module.exports = __webpack_public_path__ + "media/images/doctor_referral_icon-88676e1a3a412524f245b3972bd6404d.png";